import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import { getAccount } from "containers/AccountDetails/_actions";
import { updateMyProfile } from "containers/Auth/_actions";

class MyProfileModal extends React.Component {
    componentDidMount() {
        // Do this to force an authenticated request to api
        // to validate auth token before updating profile
        this.props.getAccount();
    }

    _validate = (values) => {
        const errors = {};

        errors.email = FormUtils.validators.required(values.email);
        errors.email = errors.email || FormUtils.validators.email(values.email);

        errors.fullName = FormUtils.validators.required(values.fullName);
        errors.fullName = errors.fullName || FormUtils.validators.maxLength(50)(values.fullName);
        errors.fullName = errors.fullName || FormUtils.validators.nameRegex(values.fullName);

        return errors;
    };

    _save = (values) => {
        this.props.updateMyProfile(values.email, values.fullName);
    };

    render() {
        const { authContext, online } = this.props;

        const viewModel = { email: authContext.email, fullName: authContext.fullName, accountType: authContext.accountType };
        const emailDisabled = viewModel.accountType === "Student";

        const title = authContext.email ? "My profile" : "Email required";
        const instructions = authContext.email ? "" : "Before you can continue using Overseer, we need to know your email address";

        return (
            <Form initialValues={viewModel} validate={this._validate} onSubmit={this._save}>
                {({ handleSubmit, submitSucceeded }) => {
                    const disableSave = !online || submitSucceeded;
                    return (
                        <Modal title={title} instructions={instructions} skinny>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="email" type="text" label="Email" disabled={emailDisabled} placeholder="Enter your email" required component={InputPack} />
                                                <Field name="fullName" type="text" label="Full Name" placeholder="Enter your full name" required component={InputPack} />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button Button--primary" disabled={disableSave}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}

export default compose(withAppContext, withActions({ getAccount, updateMyProfile }))(MyProfileModal);
